/**
 * 檔案用途區塊
 * @module FacebookSsoPage
 * @purpose 定義 Facebook SSO 頁面容器，透過版面元件包裹並呈現 Facebook 登入流程元件。
 * @external https://innotech.atlassian.net/browse/IN-52139
 */
import React from 'react';
import ContentLayout from '@shared/components/ContentLayout';
import FBLogin from '@modules/facebook/components/FacebookLogin';

/**
 * 宣告內容用途說明與單號關聯
 * @description FacebookSsoPage 頁面元件。
 * @purpose 提供 Facebook 登入頁的 UI 入口，掛載 ContentLayout 與 FBLogin。
 * @external https://innotech.atlassian.net/browse/IN-52139
 */
const FacebookSsoPage = () => {
  return (
    <ContentLayout testId="FacebookSsoPage">
      <FBLogin />
    </ContentLayout>
  );
};

export default FacebookSsoPage;

/**
 * === llm 分析紀錄區 ===
 * @llm-review-submitted-at 2026-06-14T07:11:10.183Z
 * @llm-review-model gpt-5.3-codex
 * @llm-review-note Added required three-section JSDoc annotations (top/module, declaration, bottom/LLM review) with correct tag sets and Jira URL from declaration origin ticket IN-52139, while keeping runtime logic unchanged.
 */
